import Id from './Id';
import Name from './Name';
import Status from './Status';
import Created from './Created';
import Updated from './Updated';

export const labels = {
  Id: 'Id',
  Name: 'Név',
  Status: 'Státusz',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
}, {
  value: 'Status',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
}, {
  value: 'Status',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'descending'
};

export default {
  Id,
  Name,
  Status,
  Created,
  Updated,
};
